module.exports = __webpack_public_path__ + "static/custom_checkout_page_en-477031d9335921fc93213f0ca22ad8e4.png";